import { Dialog } from '@youversion/design-system-components';
import React from 'react';

interface Props {
  cancelLabel: string;
  confirmLabel: string;
  message: string;
  onCancelClick: () => void;
  onClose: () => void;
  onConfirmClick: () => void;
  open: boolean;
  testId?: string;
}

export default function ConfirmationDialog(props: Props) {
  const {
    cancelLabel,
    confirmLabel,
    message,
    onCancelClick = () => {},
    onClose = () => {},
    onConfirmClick = () => {},
    open = false,
    testId,
  } = props;

  return open ? (
    <Dialog
      confirmationButtons={[
        {
          label: cancelLabel,
          onClick: onCancelClick,
        },
        {
          label: confirmLabel,
          onClick: onConfirmClick,
        },
      ]}
      data-testid={testId}
      dialogType='confirmation'
      heading={message}
      isDismissableOnOutsideClick={true}
      onClose={onClose}
    />
  ) : null;
}
